<template>
  <button class="menu-button" @click.stop="togglePopup">
    <svg data-v-fb2bf510="" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" x="0" y="0" viewBox="0 0 36 20" xml:space="preserve" class="">
      <path data-v-fb2bf510="" d="M2 12c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zM2 20c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zM2 4c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zM10 12h24c1.1 0 2-.9 2-2s-.9-2-2-2H10c-1.1 0-2 .9-2 2s.9 2 2 2zM10 20h24c1.1 0 2-.9 2-2s-.9-2-2-2H10c-1.1 0-2 .9-2 2s.9 2 2 2zM8 2c0 1.1.9 2 2 2h24c1.1 0 2-.9 2-2s-.9-2-2-2H10C8.9 0 8 .9 8 2z" class="st0"></path>
    </svg>
    <transition name="slide">
      <div v-show="isPopupOpen" class="menu-button__popup" @click.stop>
        <svg
          @click="togglePopup"
          class="menu-button__popup__close"
          width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M35.785 10.605C35.4113 10.2305 34.904 10.02 34.375 10.02C33.846 10.02 33.3387 10.2305 32.965 10.605L23.185 20.365L13.405 10.585C13.0313 10.2105 12.524 10 11.995 10C11.466 10 10.9587 10.2105 10.585 10.585C9.805 11.365 9.805 12.625 10.585 13.405L20.365 23.185L10.585 32.965C9.805 33.745 9.805 35.005 10.585 35.785C11.365 36.565 12.625 36.565 13.405 35.785L23.185 26.005L32.965 35.785C33.745 36.565 35.005 36.565 35.785 35.785C36.565 35.005 36.565 33.745 35.785 32.965L26.005 23.185L35.785 13.405C36.545 12.645 36.545 11.365 35.785 10.605Z" fill="black" fill-opacity="0.54"/>
        </svg>
        <router-link @click.native="togglePopup" v-if="isUserSubscribed && signedInPlatform !== 'PLAYPHONE'" :to="{ name: 'account' }">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 5C13.66 5 15 6.34 15 8C15 9.66 13.66 11 12 11C10.34 11 9 9.66 9 8C9 6.34 10.34 5 12 5ZM6 15.98C7.29 17.92 9.5 19.2 12 19.2C14.5 19.2 16.71 17.92 18 15.98C17.97 13.99 13.99 12.9 12 12.9C10 12.9 6.03 13.99 6 15.98Z" fill="black" fill-opacity="0.54"/>
          </svg>
          {{ $t('menu.account')}}
        </router-link>
        <a :href="supportUrl" target="_blank" rel="noopener" class="last-item" id="checkout-header-ajuda">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM11 19V17H13V19H11ZM14.17 12.17L15.07 11.25C15.64 10.68 16 9.88 16 9C16 6.79 14.21 5 12 5C9.79 5 8 6.79 8 9H10C10 7.9 10.9 7 12 7C13.1 7 14 7.9 14 9C14 9.55 13.78 10.05 13.41 10.41L12.17 11.67C11.45 12.4 11 13.4 11 14.5V15H13C13 13.5 13.45 12.9 14.17 12.17Z" fill="#2E3A59"/>
          </svg>
          {{ $t('menu.support') }}
        </a>
        <btn
          color="purple"
          v-if="!isLogoutLoading"
          @click="requestSignOut"
          :loading="isLogoutLoading"
          id="checkout-header-sair"
        >
          {{ $t('menu.logout') }}
        </btn>
      </div>
    </transition>
  </button>
</template>

<script>
import { mapActions, mapState } from 'vuex'

export default {
  name: 'menu-button',
  data: () => ({
    isPopupOpen: false,
    isLogoutLoading: false
  }),
  computed: {
    ...mapState({
      isUserSubscribed: state => state.user.isSubscribed,
      signedInPlatform: state => state.user.signedInPlatform
    }),
    supportUrl() {
      // if (this.signedInPlatform === 'PLAYPHONE') {
      //   return 'https://mobilesupport.playphone.com/support/solutions'
      // }

      return 'https://help.playkids.com'
    }
  },
  methods: {
    ...mapActions({ signOut: 'authentication/signOut' }),
    async requestSignOut() {
      this.isLogoutLoading = true
      await this.signOut()
      this.isLogoutLoading = false
      this.$router.push({ name: 'login' })
    },
    togglePopup () {
      this.isPopupOpen = !this.isPopupOpen
    },
    hidePopup() {
      this.isPopupOpen = false
    }
  },
  mounted() {
    document.addEventListener('click', this.hidePopup)
  },
  destroyed() {
    document.removeEventListener('click', this.hidePopup)
  }
}
</script>

<style lang="scss">
.menu-button {
  position: relative;
  display: flex;
  width: 40px;
  height: 40px;
  justify-content: center;
  align-items: center;
  border: 0;
  outline: 0;
  background: none;

  svg {
    width: 30px;
    cursor: pointer;
    fill: #98009b;
  }

  &__popup {
    position: absolute;
    top: 0;
    right: 0;

    display: flex;
    flex-direction: column;

    min-width: 160px;
    padding: 5rem 1rem 1rem 1rem;
    border: 1px solid #e8e8e8;
    border-radius: 4px;
    background: #F7F7F7;
    box-shadow: 0 4px 4px rgba(109, 109, 109, 0.1);

    &__close {
      position: absolute;
      top: .4rem;
      right: .8rem;
      cursor: pointer;
    }

    a {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      padding: 1.5rem 0 1.5rem 0;

      transition: all 0.1s;
      font-style: normal;
      font-weight: 900;
      font-size: 18px;
      line-height: 22px;
      color: #A217AB;

      text-decoration: none;
      border-top: 1px solid #606568;

      &.last-item {
        border-bottom: 1px solid #606568;
      }

      &:hover {
        color: #ce3ed1;
        background: #f9f9f9;
      }

      svg {
        margin-right: 1rem;
      }
    }

    button {
      margin-top: 1.5rem;
    }
  }
}
@media screen and (min-width: 992px) {
  .menu-button {
    &__popup {
      width: 220px;
      a {
        font-size: 24px;
        line-height: 28px;
      }
    }
  }
}
</style>
